// CONSERTO 27/08/2026 — a conta `hubsales` foi migrada pela Octadesk para o
// cluster REGIONAL `southamerica-east1-001.prod.octadesk.services/api`. O host
// antigo `api.octadesk.services` parou de atender esta conta em 26/08 21:40 UTC
// e passou a devolver 404 {"message":"Not Found"} em TODA rota de login — era
// esse 404 que caia no catch do login e virava o alerta "Nao autorizado".
//
// Fonte da verdade: o proprio app da Octadesk le
// https://cdn.octadesk.com/configurations/hubsales.json e la nao ha mais
// nenhuma referencia a api.octadesk.services.
//
// Como este e um build de CRA, a variavel entra em tempo de BUILD
// (REACT_APP_OCTADESK_API); sem ela vale o host regional atual.
export const OCTADESK_API =
  process.env.REACT_APP_OCTADESK_API ||
  'https://southamerica-east1-001.prod.octadesk.services/api';

// ── A VIRADA DA PORTA (04/09/2026) ──────────────────────────────────────
//
// O chamado aberto pelo CLIENTE nesta tela passa a nascer no NOSSO motor.
// A tela sempre foi nossa (React, servida pelo nosso LB no
// `portal-atendimento-ip`) — o que muda é o destino de um POST.
//
// Mesma regra de build do host acima: o CRA congela a variável no BUILD.
export const MOTOR_API =
  process.env.REACT_APP_MOTOR_API ||
  'https://backoffice.hubsai.com.br';
